import { InlineStatus } from '@web/components/InlineStatus'
import { Icon } from '@web/components/ui/icons'
import type { ReactNode } from 'react'

/** Present a stable, accessible status panel while a workspace or session opens. */
export function OpeningState({
  title,
  description = '',
  compact = false,
  error,
  onRetry,
  retryLabel = 'Try again',
  illustration,
  className = '',
}: {
  title: string
  description?: string
  compact?: boolean
  error?: string
  onRetry?: () => void
  retryLabel?: string
  illustration?: ReactNode
  className?: string
}) {
  const failed = Boolean(error)
  if (compact && !failed)
    return (
      <InlineStatus icon="loader" loading>
        {title}
      </InlineStatus>
    )
  return (
    <section
      className={`opening-state ${failed ? 'is-error' : ''} ${className}`}
      aria-busy={!failed}
    >
      <div
        className="opening-state-card"
        role={failed ? 'alert' : 'status'}
        aria-live={failed ? 'assertive' : 'polite'}
      >
        <div className="opening-state-icon" aria-hidden="true">
          {illustration ??
            (failed ? (
              <Icon name="warning" size={24} className="text-danger" />
            ) : (
              <span className="opening-state-skeleton" />
            ))}
        </div>
        <div className="opening-state-copy">
          <h2>{failed ? 'We couldn’t finish opening.' : title}</h2>
          <p>{failed ? error : description}</p>
        </div>
        {failed && onRetry && (
          <button type="button" className="btn btn-primary" onClick={onRetry}>
            {retryLabel}
          </button>
        )}
      </div>
    </section>
  )
}
